module.exports = __webpack_public_path__ + "static/img/5_c.90aa933.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/bba/1242x2208/5_c.png
// module id = x9yN
// module chunks = 0